import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../SimplePresentationRunner";
import {EnterFreespinsPresentation} from "./runnerpresentations/EnterFreespinsPresentation";

import {SuperFsBeforeStart} from "./runnerpresentations/superfreespin/SuperFsBeforeStart";
import {BingeSpinBeforeSpinStart} from "./runnerpresentations/bingespins/BingeSpinBeforeSpinStart";
import {SCCToXSplitBeforeSFS} from "./runnerpresentations/superfreespin/SSCToXSplitBeforeSFS";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";


export class ZeroBetIdle implements FlowStatePresentation {

    private _flowStateController: FlowStateController;
    private _presentations: SimplePresentation[];


    constructor() {

    }


    start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;
        this._presentations = [
            new EnterFreespinsPresentation(),
            new SCCToXSplitBeforeSFS(),
            new SuperFsBeforeStart(),
            new BingeSpinBeforeSpinStart()
        ]
        SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }

    public complete() {
        // console.log("Played ZeroBet: " + XwaysHoarder2.model.data.mode);

        XwaysHoarder2.keypadPlugin.setZeroBetSpinCounter(XwaysHoarder2.model.data.freespinsLeft - 1);
        //XwaysHoarder2.fsIndicators.setSpinValue(XwaysHoarder2.model.data.freespinsLeft - 1, true);

        XwaysHoarder2.waysCounter.reduceToDefault();
        SlotGame.apiPlugin.betHandler.zeroBet();
        this._flowStateController.finish();
    }


}